// extracted by mini-css-extract-plugin
export default {"timeLogSummarySpacer":"TimeLogSummary_timeLogSummarySpacer__Eno36","timeLogSummary":"TimeLogSummary_timeLogSummary__OAvi+"};